import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs/operators';

import {Store} from '@ngrx/store';
import {NotificationService} from '../../../../../services/notification.service';
import {
  clearCurrencys,
  getCurrencies,
  upsertCurrencys
} from "./currency.actions";
import {Currency} from "./currency.model";
import {AppState} from "../../../../index";
import {Location} from '@angular/common';
import {setLoadingState} from "../../../shared/loading-state/loading-state.actions";
import {GET_CURRENCIES, GET_EDUCATION_LEVELS} from "./currency.graphql";
import {PaginationService} from "../../../../../services/pagination.service";

@Injectable()
export class CurrencyEffects {

  getCurrencies = createEffect(() => this.actions$.pipe(
    ofType(getCurrencies),
    switchMap((action) => {
      this.store.dispatch(setLoadingState({ loadingState : { id: 'currency', isLoading: true}}))
      return this.apollo.query({
        query: GET_CURRENCIES,
        variables: {
          filtering: action?.filtering
        }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];
          if (result?.response?.status) {
            this.paginationService.setPage(result?.page)
            // this.store.dispatch(clearCurrencys())
            let dataValue = result?.data?.map((item: Currency) => {
              return {
                ...item,
                type: 'Currency'
              }
            })
            this.store.dispatch(upsertCurrencys({ currencys: dataValue as Currency[] }));
          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
          this.store.dispatch(setLoadingState({ loadingState : { id: 'currency', isLoading: false}}))
        })
      );
    })
  ), { dispatch: false });

  getEducationLevels = createEffect(() => this.actions$.pipe(
    ofType(getCurrencies),
    switchMap((action) => {
      this.store.dispatch(setLoadingState({ loadingState : { id: 'currency', isLoading: true}}))
      return this.apollo.query({
        query: GET_EDUCATION_LEVELS,
        variables: {
          filtering: action?.filtering
        }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];
          if (result?.response?.status) {
            this.paginationService.setPage(result?.page)
            // this.store.dispatch(clearCurrencys())
            let dataValue = result?.data?.map((item: Currency) => {
              return {
                ...item,
                type: 'EducationLevel'
              }
            })
            this.store.dispatch(upsertCurrencys({ currencys: dataValue as Currency[] }));
          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
          this.store.dispatch(setLoadingState({ loadingState : { id: 'currency', isLoading: false}}))
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private paginationService: PaginationService
  ) {
  }
}
